import styled from "styled-components";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import Profile from "../../components/allies/Me/Profile";
import Sidebar, { AllyTab } from "../../components/allies/Me/Sidebar";
import Info from "../../components/allies/Me/Info";
import Reservations from "../../components/allies/Me/Reservations";
import { mobile } from "../../styles/responsive";
import { useAlly } from "../../context/ally";
import AllyService from "../../services/ally.service";
// Mismo flujo de "agregar tour" que en el inicio del aliado, abierto desde "Mis reservas" con "+".
import AddReservationGroup from "../../components/allies/modals/AddReservationGroup";
import TicketPaymentGroup from "../../components/allies/modals/TicketPaymentGroup";
import ConfirmBoucher from "../../components/allies/modals/ConfirmBoucher";
import Summary from "../../components/allies/modals/Summary";


export default function AllyMe() {
    const {setAllyInfo,
        user,
        newGroup,
        isTicketPaymentGroupModalOpen,
        isConfirmBoucherModalOpen,
        isSummaryModalOpen,
    } = useAlly()
    const navigate = useNavigate()
    const router = useNavigate()
    // La pestaña va en la URL (?tab=reservations): "Confirmar" del voucher recarga la página, y así
    // el aliado vuelve a quedar en "Mis reservas" en vez de en el perfil.
    const [searchParams, setSearchParams] = useSearchParams()
    const tab: AllyTab = searchParams.get('tab') === 'reservations' ? 'reservations' : 'profile'
    function setTab(next: AllyTab) {
        setSearchParams(next === 'profile' ? {} : { tab: next })
    }
    function back() {
        navigate('/ally')
    }

    useEffect(() => {
        if (!user) return router('/ally/access')
    }, [user, router])

    useEffect(() => {
        async function me() {
            try {
                const response = await (await AllyService.me()).data
                setAllyInfo(response)
            } catch (error) {
                console.log(error)
            }
        }
        me()
    }, [])

    return (
        <Main>
            <Navbar>
                <button onClick={back}>
                    <IoMdArrowRoundBack/>
                </button>
            </Navbar>
            <Left>
                <Profile/>
                <Sidebar tab={tab} setTab={setTab}/>
            </Left>
            <Right>
                {tab === 'profile' && <Info/>}
                {tab === 'reservations' && <Reservations/>}
            </Right>
            {
                newGroup.length > 0 &&
                <AddReservationGroup/>
            }
            {
                isTicketPaymentGroupModalOpen &&
                <TicketPaymentGroup/>
            }
            {
                isConfirmBoucherModalOpen &&
                <ConfirmBoucher/>
            }
            {
                isSummaryModalOpen &&
                <Summary/>
            }
        </Main>
    )
}

const Main = styled.div`
display: grid;
width: 80%;
margin: auto;
min-height: 100dvh;
padding-bottom: 5vh;
grid-template-columns: 1fr 1fr 1fr;
/* grid-template-rows: 70px 1fr 1fr; */
/* ${mobile({
    width: '90%'
})} */
`

const Navbar = styled.div`
grid-column: 1 / -1;
padding: 20px 0;
button {
    height: 30px;
    width: 30px;
    background-color: rgba(0,0,0,0);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;
}
`

const Left = styled.div`
grid-column: 1 / span 1;
${mobile({
    gridColumn: '1 / -1',
    gridRow: '2 / span 1'
})}
`
const Right = styled.div`
grid-column: 2 / -1;
${mobile({
    gridColumn: '1 / -1',
    gridRow: '3 / span 1'
})}
`